// const url = 'http://172.20.14.59:9999'
import CryptoJS from "crypto-js";
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store'
import request from '@/util/http'
Vue.use(Router);
export default {
  //获取策略符号
  getStrategySymbol(data) {
    if (data === 0) {
      return ">";
    } else if (data === 1) {
      return "<";
    } else if (data === 2) {
      return "=";
    } else if (data === 3) {
      return "≥";
    } else if (data === 4) {
      return "≤";
    } else {
      return "";
    }
  },
  //获取list对象的id
  assemblId: function (arr) {
    let arr1 = [];
    if (arr == '') {} else {
      for (let i = 0; i < arr.length; i++) {
        arr1.push(arr[i].id);
      }
    }
    return arr1;
  },
  //获取list对象的name
  assemblName: function (arr) {
    let str = "";
    if (arr == '') {} else {
      for (let i = 0; i < arr.length; i++) {
        str = str + "," + arr[i].name;
      }
      str = str.substring(1);
    }
    return str;
  },
  //获取路径传参值
  getUrlParam: function (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
    let r = window.location.search.substr(1).match(reg); // 匹配目标参数
    if (r != null)
      return unescape(r[2]);
    return null; // 返回参数值
  },

  /**
   * long型日期格式化为YYYY-MM-dd HH:mm:ss
   * @param date
   * @returns {string}
   */
  dateFormat: function (date) {
    if (date == null || date == '') {
      return '';
    } else {
      let mDate = new Date(date);
      let seperator1 = "-";
      let seperator2 = ":";
      let month = mDate.getMonth() + 1;
      let strDate = mDate.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      let hour = mDate.getHours();
      if (hour <= 9 && hour >= 0) {
        hour = '0' + hour;
      }

      let minutes = mDate.getMinutes();
      if (minutes <= 9 && minutes >= 0) {
        minutes = '0' + minutes;
      }
      let currentdate = mDate.getFullYear() + seperator1 + month + seperator1 + strDate +
        " " + hour + seperator2 + minutes;
      return currentdate;
    }
  },
  /**
   * 获取网站跟路径
   */
  getRootPath: function () {
    // let strFullPath = window.document.location.href;
    // let strPath = window.document.location.pathname;
    // let pos = strFullPath.indexOf(strPath);
    // let prePath = strFullPath.substring(0, pos);
    // let postPath = strPath.substring(0, strPath.substr(1).indexOf('/') + 1);
    //let postPath="/" + location.pathname.split("/")[1];
    //         return(prePath+postPath);
    //         return (prePath);//这里没有项目名，就直接返回前缀

    // 采用hash模式strPath路径获取出错，重新写的方法
    let strFullPath = window.document.location.href;
    let pathList = strFullPath.split("/");
    let prePath = pathList[0] + "/" + pathList[1] + "/" + pathList[2];
    return prePath;
  },

  /**
   * 获取websocket路径
   */
  getSocketPath: function () {
    let path = this.getRootPath();
    let rePath = path.split(":")[0];
    return path.replace(rePath, "ws");
  },


  parseTreeToRow(node, data = [], row = []) {
    if (!node.children) {
      data.push(row);
    } else {
      for (let i = 0; i < node.children.length; i++) {
        const child = node.children[i];
        const cell = {
          value: child.value
        };
        /******************添加的代码******************/
        //深度克隆父亲，因为后代共用了该引用数据
        const extendRow = [...JSON.parse(JSON.stringify(row)), cell];
        if (extendRow.length === 1) { //第一列
          extendRow[0].rowspan = 1;
        } else if (extendRow.length > 1) {
          //将该行的最后一列的rowspan赋给上一列
          //再将自身置为1(避免最后一列无值)
          extendRow[extendRow.length - 2].rowspan = i === 0 ? this.computeLeafCount(node) : 0;
          extendRow[extendRow.length - 1].rowspan = 1;
        }
        /******************添加的代码******************/
        this.parseTreeToRow(child, data, extendRow);
      }
    }
    return data;
  },

  /**
 1. 计算某个节点下叶子节点的数量
 2. @param { Object }    node        节点
 3. @returns { Number }  leafCount   叶子节点的数量
   */
  computeLeafCount(node) {
    if (!node.children) {
      node.rowspan = 1;
      return 1;
    } else {
      let leafCount = 0;
      for (let i = 0; i < node.children.length; i++) {
        leafCount = leafCount + this.computeLeafCount(node.children[i]);
      }
      node.rowspan = leafCount;
      return leafCount;
    }
  }


}

/**
 * 获取文件后缀名
 */
export const getfileName = (name) => {
  let index = name.lastIndexOf(".")
  let str = name.substring(index + 1, name.length)
  return str;
}
/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
  if (date) random = random + Date.now()
  return random
}
/**
 *加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      key = CryptoJS.enc.Latin1.parse(key)
      var iv = key
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        data,
        key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
};
/**
 *加密处理2
 */
 export const encryptionNew = (word, keyStr) => {
  keyStr = keyStr ? keyStr : "abcdsxyzhkj12345"; //判断是否存在ksy，不存在就用定义好的key
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: key,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return encrypted.toString();
};
export const decrypt = (word, keyStr) => {
  keyStr = keyStr ? keyStr : "abcdsxyzhkj12345";
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};
/**
 * 打开小窗口
 */
export const openWindow = (url, title, w, h) => {
  // Fixes dual-screen position                            Most browsers       Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

  const left = ((width / 2) - (w / 2)) + dualScreenLeft
  const top = ((height / 2) - (h / 2)) + dualScreenTop
  const newWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left)

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus()
  }
};
/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value == value) {
      return i
    }
  }
  return -1
};
/**
 * 判断路由是否相等
 */
export const isObjectValueEqual = (a, b) => {
  let result = true
  Object.keys(a).forEach(ele => {
    const type = typeof (a[ele])
    if (type === 'string' && a[ele] !== b[ele]) result = false
    else if (type === 'object' && JSON.stringify(a[ele]) !== JSON.stringify(b[ele])) result = false
  })
  return result
};
/**
 * 动态插入css
 */

export const loadStyle = url => {
  const link = document.createElement('link')
  link.type = 'text/css'
  link.rel = 'stylesheet'
  link.href = url
  const head = document.getElementsByTagName('head')[0]
  head.appendChild(link)
};
/**
 * 递归寻找子类的父类
 */

export const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children.length != 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id == id) {
          return menu[i]
        } else {
          if (menu[i].children[j].children.length != 0) {
            return findParent(menu[i].children[j].children, id)
          }
        }
      }
    }
  }
};
/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen();
  }
};
/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  }
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
  return document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
};
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
  function listen() {
    callback()
  }
  document.addEventListener("fullscreenchange", function () {
    listen();
  });
  document.addEventListener("mozfullscreenchange", function () {
    listen();
  });
  document.addEventListener("webkitfullscreenchange", function () {
    listen();
  });
  document.addEventListener("msfullscreenchange", function () {
    listen();
  });
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen();
  } else {
    reqFullScreen();
  }
};
/**
 * 设置主题
 */
export const setTheme = (name) => {
  document.body.className = name
};
/**
 * 判断路由是否相等
 */
export const diff = (obj1, obj2) => {
  delete obj1.close
  var o1 = obj1 instanceof Object
  var o2 = obj2 instanceof Object
  if (!o1 || !o2) { /*  判断不是对象  */
    return obj1 === obj2
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false
    // Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
  }

  for (var attr in obj1) {
    var t1 = obj1[attr] instanceof Object
    var t2 = obj2[attr] instanceof Object
    if (t1 && t2) {
      return diff(obj1[attr], obj2[attr])
    } else if (obj1[attr] !== obj2[attr]) {
      return false
    }
  }
  return true
};
/**
 * 对象深拷贝
 */
export const deepClone = data => {
  var type = getObjType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
};
export const getObjType = obj => {
  var toString = Object.prototype.toString;
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
};
// 表单序列化
export const serialize = data => {
  let list = [];
  Object.keys(data).forEach(ele => {
    list.push(`${ele}=${data[ele]}`)
  })
  return list.join('&')
}
/**
 * 处理用户类型
 */
export const dealRoleType = (value) => {
  let type;
   store.getters.userTypes.forEach(item=>{
    if(value==item.value){
      type=item.label
    }
  })
  return type
};
/**
 * 处理角色类型
 */
export const dealRoleTypeData=(value)=>{
    let type;
  store.getters.roleTypeData.forEach(item=>{
    if(value==item.value){
      type=item.label
    }
  })
  return type
}
/**
 * 字符串转化为数组
 */
export const stringToArray=(value)=>{
  if(value){
    // return value.split(",");
    const permissionArray=value.split(",")
    let dealArray=[];
    let lastArray=[];
    store.state.user.userMenus.forEach((item,index)=>{
      if(permissionArray.includes(item.name)){
        dealArray.push(item.name)
      }else{
        permissionArray.forEach((value,key)=>{
          if(!dealArray.includes(value)&&!lastArray.includes(value)){
            lastArray.push(value);
          }
        })
      }
    })
    // if(dealArray.length>0){
    //   return dealArray;
    // }else{
    //   return lastArray;
    // }
    return Array.from(new Set([].concat(dealArray,lastArray)));
  }else{
    return []
  }
}
// export const selectOptionValue = (optiondatas, selectvalue)=> {
//     for (var i = 0; i < optiondatas.length; i++) {
//         if (optiondatas[i].value == selectvalue) {
//             return i;
//         }
//     }
//     return 0;
// }
/**
 * 下拉框选择ID
 */
export const selectOptionValue =  (optiondatas, selectvalue)=> {
    for (var i = 0; i < optiondatas.length; i++) {
        if (optiondatas[i].value == selectvalue) {
            return optiondatas[i].label;
        }
    }
    return 0;
}
export const dataGEt =  (data)=> {
    var d = new Date(data);
    let Month = d.getMonth() + 1
    let getDate = d.getDate()
    let m= Month < 10 ? ('0'+ Month) :Month
    let g= getDate < 10 ? ('0'+ getDate) :getDate
    let youWant=d.getFullYear() + '-' + m + '-' + g  ;
    return youWant
}
const getDateTimeStamp =(dateStr)=>{
    return Date.parse(dateStr.replace(/-/gi,"/"));
}
export const getDateDiff =(dateStr)=>{
    let publishTime = getDateTimeStamp(dateStr)/1000,
        d_seconds,
        d_minutes,
        d_hours,
        d_days,
        timeNow = parseInt(new Date().getTime()/1000),
        d,

        date = new Date(publishTime*1000),
        Y = date.getFullYear(),
        M = date.getMonth() + 1,
        D = date.getDate(),
        H = date.getHours(),
        m = date.getMinutes(),
        s = date.getSeconds();
    //小于10的在前面补0
    if (M < 10) {
        M = '0' + M;
    }
    if (D < 10) {
        D = '0' + D;
    }
    if (H < 10) {
        H = '0' + H;
    }
    if (m < 10) {
        m = '0' + m;
    }
    if (s < 10) {
        s = '0' + s;
    }

    d = timeNow - publishTime;
    d_days = parseInt(d/86400);
    d_hours = parseInt(d/3600);
    d_minutes = parseInt(d/60);
    d_seconds = parseInt(d);

    if(d_days > 0 && d_days < 3){
        return d_days + '天前';
    }else if(d_days <= 0 && d_hours > 0){
        return d_hours + '小时前';
    }else if(d_hours <= 0 && d_minutes > 0){
        return d_minutes + '分钟前';
    }else if (d_seconds < 60) {
        if (d_seconds <= 0) {
            return '刚刚发表';
        }else {
            return d_seconds + '秒前';
        }
    }else if (d_days >= 3 && d_days < 30){
        return M + '-' + D + ' ' + H + ':' + m;
    }else if (d_days >= 30) {
        return Y + '-' + M + '-' + D + ' ' + H + ':' + m;
    }
}

export function generateRandomData(len) {
  // use web crypto APIs if possible
  var array = null;
  var crypto = window.crypto || window.msCrypto;
  if (crypto && crypto.getRandomValues && window.Uint8Array) {
      array = new Uint8Array(len);
      crypto.getRandomValues(array);
      return array;
  }

  // fallback to Math random
  array = new Array(len);
  for (var j = 0; j < array.length; j++) {
      array[j] = Math.floor(256 * Math.random());
  }
  return array;
}

export function generateCodeVerifier(len) {
  return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
}

export function generateRandomString(len, alphabet){
  var randomData = generateRandomData(len);
  var chars = new Array(len);
  for (var i = 0; i < len; i++) {
      chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
  }
  return String.fromCharCode.apply(null, chars);
}


export function _debounce(func, delay) {
  let timeout
  return function () {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(this, arguments)
    }, delay)
  }
}

export function _throttle(fn, interval) {
  var last;
  var timer;
  var interval = interval || 200;
  return function () {
    var th = this;
    var args = arguments;
    var now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.apply(th, args);
      }, interval);
    } else {
      last = now;
      fn.apply(th, args);
    }
  }
}

//验证码检验
export const checkCode = url =>
  request({
    headers: {
      "Content-Type": "application/json",
    },
    url: url,
    method: "get",
  });